export enum OrganicMatterBalanceEvents {
   
  CompletedGenerateOrganicMatterBalance = 'Arable_CompletedGenerateOrganicMatterBalance',
}

export interface CompletedGenerateOrganicMatterBalance {
  isSuccessful: boolean;
  year: number;
  cropFieldId: number;
  organicMatterBalance: number;
}
